import Dinero from 'dinero.js';
import { captureException } from '@core/plugins/sentry';

const isValidLocale = (locale: string): boolean => {
  try {
    Intl.getCanonicalLocales(locale);
    return true;
  } catch {
    return false;
  }
};

export const priceFormatter = (price: Dinero.Options, format: string, locale: string): string => {
  const safeLocale = locale && isValidLocale(locale) ? locale : undefined;
  try {
    return Dinero(price)
      .setLocale(safeLocale)
      .toFormat(format ?? undefined);
  } catch (error) {
    captureException(error);
    // dont break the JS;
    return '';
  }
};
